<template>
  <b-modal
    id="modal-center"
    ref="modal-center"
    style="position: absolute;"
    centered
    :title="$t('titles.title_transition')"
    :ok-only="true"
    :ok-title="$t('button.validate')"
    @ok=""
    @hidden="$emit('close')"
  >
    <section id="contentIn">
      <div
        id="no-transition-in"
        class="mode_transition"
        @click="setTransition('no-transition')"
        :class="{ selected: transition === 'no-transition' }"
      >
        <img src="/static/images/icons/transitions/none.svg" />
        <div class="label mt-2">{{ $t('modal.setting.animation.without_transition') }}</div>
      </div>
      <div
        id="transition-right-in"
        class="mode_transition"
        @click="setTransition('slide')"
        :class="{ selected: transition === 'slide' }"
      >
        <img src="/static/images/icons/transitions/slide.svg" />
        <div class="label mt-2">Slide</div>
      </div>
      <div
        id="transition-left-in"
        class="mode_transition full"
        @click="setTransition('convex')"
        :class="{ selected: transition === 'convex' }"
      >
        <img src="/static/images/icons/transitions/convex.svg" />
        <div class="label mt-2">{{ $t('modal.setting.animation.convex') }}</div>
      </div>
      <div
        id="transition-top-in"
        class="mode_transition top"
        @click="setTransition('concave')"
        :class="{ selected: transition === 'concave' }"
      >
        <img src="/static/images/icons/transitions/concave.svg" />
        <div class="label mt-2">Concave</div>
      </div>
      <div
        id="transition-bottom-in"
        class="mode_transition bottom"
        @click="setTransition('fade')"
        :class="{ selected: transition === 'fade' }"
      >
        <img src="/static/images/icons/transitions/fade.svg" />
        <div class="label mt-2">{{ $t('modal.setting.animation.fade-in') }}</div>
      </div>
      <div
        id="transition-zoom-in"
        class="mode_transition zoom"
        @click="setTransition('zoom')"
        :class="{ selected: transition === 'zoom' }"
      >
        <img src="/static/images/icons/transitions/zoom.svg" />
        <div class="label mt-2">{{ $t('modal.setting.animation.grow') }}</div>
      </div>
    </section>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'TransitionModal',
  data() {
    return {
      transitionSegment: null,
    };
  },
  computed: {
    ...mapGetters({
      getSegmentByUid: 'segments/getSlideByUid',
      getSlideByUid: 'slides/getSlideByUid',
    }),
    transition() {
      let slide;
      if (this.$route.name === 'segment') {
        slide = this.getSlideByUid(this.slide.uid);
      } else {
        slide = this.getSegmentByUid(this.slide.uid);
      }
      return slide && slide.transition.in
        ? slide.transition.in.replace('-in', '')
        : 'no-transition';
    },
  },
  props: {
    slide: Object,
  },
  mounted() {},
  methods: {
    /**
     * Actions from Vuex Store
     */
    ...mapActions('slides', ['setSlideTransition']),
    ...mapActions('segments', ['setSegmentTransition']),
    ...mapActions('common', ['setShowIconSave']),
    setTransition(transition) {
      this.transitionSegment = transition;
      const data = {
        uid: this.slide.uid,
        name: transition,
      };
      if (this.$route.name === 'segment') {
        this.setSlideTransition(data);
      } else {
        this.setSegmentTransition(data);
      }
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      }
    },
  },
};
</script>

<style lang="scss">
div#modal-center___BV_modal_content_ {
  border-radius: 3px;
}

header#modal-center___BV_modal_header_ {
  background-color: rgb(59, 151, 227);
  color: #ffffff;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

button.close {
  color: #ffffff;
  &:hover {
    color: #ffffff;
  }
}

section#contentIn {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  flex-wrap: wrap;
  margin: 0 -5px;
}

.mode_transition {
  cursor: pointer;
  flex: 1 0 30%;
  border: 1px solid #cad4d9;
  padding: 12px 20px;
  border-radius: 2px;
  position: relative;
  margin: 5px;
  &:before {
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid #c5c5c5;
    margin: 5px;
    border-radius: 10px;
  }
  &.selected {
    &:after {
      content: '';
      width: 16px;
      height: 16px;
      position: absolute;
      left: 0;
      top: 0;
      margin: 7px;
      border-radius: 10px;
      background-color: rgba(59, 151, 227, 0.6);
    }
  }
  img {
    width: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// TransitionModal.vue?0f2187d4